import { call, put, takeLatest } from "redux-saga/effects";
// Login Redux States
import { GET_USER, EDIT_USER } from "./actionTypes";
import { getUser, editUser } from "../../http/fundLync/user.helper";
import { allUser } from "../actions";



function* getUsers({ payload: { user } }) {
  try {
    const responseFromAPI = yield call(getUser, user);
    if (responseFromAPI.code == 200) {
      const { data } = responseFromAPI;
      yield put(allUser({ data }));
    }
  } catch (error) {
    console.log("error", error);
  }
}

function* editUsers({ payload: { user } }) {
  try {
    yield call(editUser, user);
  } catch (error) {
    console.error("error", error);
  }
}

function* userSaga() {
  yield takeLatest(GET_USER, getUsers);
  yield takeLatest(EDIT_USER, editUsers);
}

export default userSaga;
